import { weeklyResults, recurringTopics } from './post-session-overview';
const percent = (correct, total) => `${Math.round(correct / total * 100)}%`;
export default function PostSessionLearning({ rows, showTopics = false }) {
  const weeks = weeklyResults(rows), topics = showTopics ? recurringTopics(rows) : [];
  return <div className="psq-learning">
    <h4>Learning over time</h4>
    <p className="mtr-sub">Completed post-session quizzes shown here, grouped by completion week. Link opens are not study activity.</p>
    {weeks.length ? <table className="psq-trends">
      <caption className="psq-sr-only">Weekly post-session learning</caption>
      <thead><tr><th scope="col">Week of</th><th scope="col">Answered</th><th scope="col">Accuracy</th></tr></thead>
      <tbody>{weeks.map(week => <tr key={week.date.getTime()}>
        <th scope="row">{week.date.toLocaleDateString(undefined, {month:'short', day:'numeric', year:'numeric'})}</th>
        <td>{week.recorded ? week.answered : 'Unavailable'}
          {week.recorded > 0 && week.recorded < week.quizzes && <span className="psq-meta mtr-sub">Some answer data unavailable</span>}</td><td>{week.total ? <>{percent(week.correct, week.total)} <span className="mtr-sub">({week.correct}/{week.total})</span></> : 'Unavailable'}
          {week.scored < week.quizzes && <span className="psq-meta mtr-sub">Some scores unavailable</span>}</td>
      </tr>)}</tbody>
    </table> : <p className="mtr-sub">Trends appear when completed quizzes have recorded answer data.</p>}
    {showTopics && <><h4>Topics to revisit</h4>{topics.length ? <ul>{topics.map(item => <li key={item.topic}>
      <strong>{item.topic}</strong> — {item.missed} missed answers across {item.quizzes} quizzes
    </li>)}</ul> : <p className="mtr-sub">Topics appear here when recorded answers show misses in at least two completed quizzes.</p>}</>}
  </div>;
}
